import Message from './src/main.js';
import '@/theme/css/basic/message.scss';
export default Message;